<template>
  <div class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-header">
          <h4 class="title">Select Field 
            <span class="component-name">&lt;ed-select /&gt;</span>
          </h4>
          <p class="component-description">The &lt;ed-select /&gt tag specifies a select field.</p>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-6"><h5 class="section-header">Select Field Types</h5>
              <ed-select :options="options1" field-label="Single Select, Required" required />
              <ed-select :options="options2" field-label="Single Select, Required, With Helptip" helptipBody="This is a helptip, letting you know what to do." required />
              <ed-select v-model="value" :options="options3" label="title" track-by="title" field-label="Sinlge Select, With Images" helptipBody="This is a helptip, letting you know what to do." required >
                <template slot="option" slot-scope="props">
                  <ed-select-options thumbnails>
                    <img slot="image" :src="props.option.img">
                    <p slot="row1">{{ props.option.title }} ({{ props.option.number }})</p>
                    <p slot="row2">{{ props.option.tags }}</p>
                  </ed-select-options>
                </template>
              </ed-select>
              <ed-select :options="options4" label="full_name" track-by="full_name" field-label="Content Select, No Images">
                <template slot="option" slot-scope="props">
                  <ed-select-options>
                    <p slot="row1">{{ props.option.full_name }}</p>
                    <p slot="row2">{{ props.option.email }}</p>
                  </ed-select-options>
                </template>
              </ed-select>
              <ed-select :options="options5" label="full_name" track-by="full_name" field-label="Content Select, No Images, More Data">
                <template slot="option" slot-scope="props">
                  <ed-select-options>
                    <p slot="row1">{{ props.option.full_name }}</p>
                    <p slot="row2">{{ props.option.email }}</p>
                    <p slot="row3">O: {{ props.option.office }}</p>
                    <p slot="row4">C: {{ props.option.cell }}</p>
                  </ed-select-options>
                </template>
              </ed-select>
            </div>
            <div class="col-md-6">
              <!-- Another column, if you need it !-->
            </div>
          </div>
          <div class="row">
            <div class="col-md-12"><h5 class="section-header">Select Field Code</h5>
              <pre>
                <code>
                  Code Example Here
                </code>
              </pre>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ed-button class="btn btn-primary" @click="showModal1 = true">Launch Modal 1</ed-button>
              <ed-modal :show="showModal1" @close="showModal1 = false" title="Budget Information" subtitle="Tell us about your budget.">
                <div slot="body">
                  <program-list legacy='true' />
                </div>
              </ed-modal>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
    <div class="container-fluid">
      <div class="card">
        <div class="card-header">
          <h4 class="title">Tab Nav
            <span class="component-name">&lt;ed-tab-nav /&gt;</span>
          </h4>
          <p class="component-description">The &lt;ed-tab-nav /&gt tag adds a slick tab nav.</p>
        </div>
          <div class="card-content">
            <div class="row">
              <div class="col-md-12"><h5 class="section-header">Tab Nav Demo</h5>
                <ed-tab-nav class="uniform" workflow>
                  <ed-tab title="Completed Agenda" :completed="true" :icon="['fal', 'list-alt']">
                    <project-agenda />
                  </ed-tab>
                  <ed-tab title="Project Information" :active="true" :icon="['fal', 'clipboard']">
                    <project-information />
                  </ed-tab>
                  <ed-tab title="Clients" :completed="true" :icon="['fal', 'address-book']">
                    <project-clients />
                  </ed-tab>
                  <ed-tab title="Services" :icon="['fal', 'shopping-basket']">
                    <project-services />
                  </ed-tab>
                  <ed-tab title="Design &amp; Layout" :icon="['fal', 'paint-brush']">
                    <project-design />
                  </ed-tab>
                  <ed-tab title="Project Settings" :icon="['fal', 'rocket']">
                    <project-settings />
                  </ed-tab>
                </ed-tab-nav>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12"><h5 class="section-header">Tab Nav Code</h5>
                <pre>
                  <code>
                    Code Example Here
                  </code>
                </pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import ProgramList from '@/components/_modules/Programs/Program-list'
import model from '@/components/_modules/Programs/Program-list/model'

export default {
  name: 'SelectField',
  components: {
    ProgramList
  },
  data () {
    return {
      model,
      showModal1: false,
      value: null,
      options1: ['list', 'of', 'options', 'many', 'many', 'options'],
      options2: ['a', 'totally', 'different', 'list', 'of', 'options'],
      options3: [
        { title: 'Sierra Suites', number: '2403', tags: 'Rentals, Decor, Entertainment, Gifts & Amenities', img: 'static/demo-logos/logo_1.png' },
        { title: 'Westmore Hotel', number: '2675', tags: 'Gifts & Amenities, A/V, Decor', img: 'static/demo-logos/logo_2.png' },
        { title: 'Pagoda Inn', number: '6604', tags: 'Catering, Entertainment', img: 'static/demo-logos/logo_3.png' },
        { title: 'The Swedish Meatball', number: '9823', tags: 'Rentals, Decor, A/V, Gifts & Amenities', img: 'static/demo-logos/logo_4.png' },
        { title: 'Dapper Dining', number: '45303', tags: 'Decor, Entertainment, Gifts & Amenities', img: 'static/demo-logos/logo_5.png' }
      ],
      options4: [
        {full_name: 'Sauncho Winsley', email: 'swinsley0@si.edu'},
        {full_name: 'Janeta Stiles', email: 'jstiles1@census.gov'},
        {full_name: 'Clay Naisbitt', email: 'cnaisbitt2@naver.com'},
        {full_name: 'Gusta Restieaux', email: 'grestieaux3@newsvine.com'},
        {full_name: 'Kelsey Trosdall', email: 'ktrosdall4@timesonline.co.uk'}
      ],
      options5: [
        {full_name: 'Sauncho Winsley', email: 'swinsley0@si.edu', office: '333-444-5555', cell: '666-777-8888'},
        {full_name: 'Janeta Stiles', email: 'jstiles1@census.gov', office: '333-444-5555', cell: '666-777-8888'},
        {full_name: 'Clay Naisbitt', email: 'cnaisbitt2@naver.com', office: '333-444-5555', cell: '666-777-8888'},
        {full_name: 'Gusta Restieaux', email: 'grestieaux3@newsvine.com', office: '333-444-5555', cell: '666-777-8888'},
        {full_name: 'Kelsey Trosdall', email: 'ktrosdall4@timesonline.co.uk', office: '333-444-5555', cell: '666-777-8888'}
      ]
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// SelectField.vue?2d89419c